<template>
  <div class="clock" v-show="show">
    <div
      class="clock-card"
      v-for="(item, index) in list"
      :key="index"
      @click="handlerCardClick(item.detail_id, item.is_unlock)"
    >
      <h4 class="title" :class="{ 'gray-font': !item.is_unlock }">
        {{ item.title }}
      </h4>
      <img
        src="@/assets/catalog_icon_lock@2x.png"
        alt="unlock"
        class="unlock-icon"
        v-if="!item.is_unlock"
      />
      <div class="tip-text">
        <div>{{ item.unlock_time.substr(0, 10) }}</div>
        <div v-if="item.is_unlock">
          已点评{{ item.punch_reply }}/{{ item.punch_count }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClassClocks } from '@/api/clockin';
import { ref, watch } from '@vue/composition-api';
import router from '@/router';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    classId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const list = ref([]);

    watch(
      () => props.show,
      (val) => {
        // 当show的值为true时，且未请求过数据，则请求后台数据并赋值给list
        if (!val) {
          return;
        }

        if (list.value.length > 0) {
          return;
        }

        getClassClocks(props.classId).then((data) => {
          list.value = data.items;
        });
      }
    );

    /**
     * @description 打卡卡片点击事件
     * @param {number} detailId 学习小结ID
     * @param {number} isUnlock 是否解锁了，0未解锁，1解锁了
     */
    const handlerCardClick = (detailId, isUnlock) => {
      // 只有解锁了才跳转到打卡主题页
      if (!isUnlock) {
        return;
      }

      router.push({
        path: '/clock-in-theme',
        query: {
          id: detailId,
          admin: 1,
          classId: props.classId
        },
      });
    };

    return {
      list,
      handlerCardClick,
    };
  },
};
</script>

<style lang="stylus" scoped>
.clock {
  padding: 16px;

  .clock-card {
    position: relative;
    margin-bottom: 16px;
    padding: 16px;
    background: #F6F7FA;
    border-radius: 4px;

    .title {
      margin-right: 30px;
      height: 24px;
      font-size: 16px;
      color: #191919;
      font-weight: 500;
      line-height: 24px;

      word-break: break-all;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }

    .unlock-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 24px;
      height: 24px;
    }

    .gray-font {
      color: #999;
    }

    .tip-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 8px;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
